<div (click)="gotoProfile()" class="avatar-main">
    <div (click)="gotoProfile()" class="avatar">
        <img [src]="imageUrl" />
    </div>
    <span class="username">{{ profile.name }}</span>
</div>
